import { SignInUrlBuilder } from '@tableau/shared-urls';
import * as React from 'react';

import { LoginSitePickerComponent } from '~src/common/react/components/LoginSitePickerComponent';

import { MobileAppBanner } from '../../../mobile/components/MobileAppBanner';
import { ProcessAndRemoveSamlQueryWrapper } from '../RouterHelpers/ProcessAndRemoveSamlQueryWrapper';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';

export interface SitePickerProviderProps {
  readonly routeLocationSearch: string;
}

export function SitePickerProvider(props: SitePickerProviderProps): JSX.Element {
  return (
    <DefaultServerTitleWrapper>
      <ProcessAndRemoveSamlQueryWrapper>
        <div>
          <MobileAppBanner />
        </div>
        <div>
          <LoginSitePickerComponent {...this.props} sitePickerQueryParams={SignInUrlBuilder.queryParamsFromQuery(props.routeLocationSearch)}/>
        </div>
      </ProcessAndRemoveSamlQueryWrapper>
    </DefaultServerTitleWrapper>
  );
}
